
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.413 17c-.388 0-.765-.127-1.072-.361l-3.48-2.641-2.335 2.523a.881.881 0 01-1.228.05.844.844 0 01-.239-.374l-1.745-5.653-3.13-1.066a1.761 1.761 0 01-.844-.612 1.705 1.705 0 01-.054-1.962c.195-.294.477-.523.808-.656L16.572.128a1.798 1.798 0 011.789.269c.246.2.431.46.538.754.106.294.13.612.066.918l-2.818 13.55c-.083.39-.301.74-.617.991-.316.252-.71.39-1.117.39z","fill":"#B7E4C7"}}),_c('path',{attrs:{"d":"M6.773 18a.916.916 0 01-.522-.161.821.821 0 01-.316-.42l-1.897-5.86a.768.768 0 01.03-.554.841.841 0 01.403-.409l9.25-4.503a.93.93 0 01.602-.072.881.881 0 01.508.313.78.78 0 01-.088 1.063l-6.2 5.798-.913 4.151a.81.81 0 01-.288.458.91.91 0 01-.529.195l-.04.001z","fill":"#52B788"}})])
          )
        }
      }
    